import React from 'react'
import { ENQUIRIES_RESOLVE_DISPUTES_ISSUES_URL } from '../../public/external-links'

const govCMSHome = process.env.REACT_APP_GOVCMS_HOME

const UnpaidWagesHeader = () => {
  return (
    <>
      <h1>Search for unpaid wages</h1>
      <p className="intro">
        Find out if we&apos;re holding your unpaid wages in trust for you.
      </p>
      <h2 className="link-list">On this page:</h2>
      <ul className="link-list">
        <li>
          <a href="#why-we-collect-unpaid-wages">
            Why we collect unpaid wages for employees
          </a>
        </li>
        <li>
          <a href="#what-happens-to-the-wages">
            What happens to the wages after we collect them
          </a>
        </li>
        <li>
          <a href="#find-out-if-we-are-holding-wages">
            Find out if we are holding wages for an employee
          </a>
        </li>
        <li>
          <a href="#tools-and-resources">Tools and resources</a>
        </li>
        <li>
          <a href="#related-information">Related information</a>
        </li>
      </ul>
      <div className="message">
        If you need help sorting out a workplace wages issue, check &nbsp;
        <a href={ENQUIRIES_RESOLVE_DISPUTES_ISSUES_URL}>
          Fixing a workplace problem
        </a>
        .
      </div>

      <h2>
        <a id="why-we-collect-unpaid-wages" aria-hidden></a>
        Why we collect unpaid wages for employees
      </h2>
      <p>
        Sometimes an employer owes wages to an employee who has left their
        business and can&apos;t be contacted.
      </p>
      <p>An employer might have to pay outstanding wages because:</p>
      <ul>
        <li>
          we have contacted the employer as part of a campaign and:
          <ul>
            <li>
              completed an audit or helped them to do an audit of their records
            </li>
            <li>found that one or more former employees have been underpaid</li>
          </ul>
        </li>
        <li>during an investigation we have found an underpayment.</li>
      </ul>

      <h2>
        <a id="what-happens-to-the-wages" aria-hidden></a>
        What happens to the wages after we collect them
      </h2>
      <p>
        We hold the wages on behalf of the employee. When the employee is found
        and identified, we pay the wages to the employee.
      </p>

      <h2>
        <a id="find-out-if-we-are-holding-wages" aria-hidden></a>
        Find out if we are holding wages for an employee
      </h2>
      <p>Fill in this form to search our database.</p>
      <p>You might need to do a few separate searches if:</p>
      <ul>
        <li>the employee has had more than one employer</li>
        <li>the employee has changed their name since they started working.</li>
      </ul>
      <p>
        If your search shows we might be holding unpaid wages for an employee,
        the employee should{' '}
        <a href={govCMSHome + '/about-us/contact-us'}>Contact us</a>.
      </p>
    </>
  )
}

export default UnpaidWagesHeader
